import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.href
      ? { '@id': `https://magnetlink-guide.com${item.href}`, name: item.label }
      : { name: item.label },
  }));

  return (
    <>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <span className="w-3 h-3 flex items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-600 transition-colors duration-200 no-underline"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: schemaItems,
        })}
      </script>
    </>
  );
}

export function getCategoryBreadcrumb(slug: string): BreadcrumbItem[] {
  const category = categories.find((c) => c.slug === slug);
  return [
    { label: '首页', href: '/' },
    { label: category?.name || '分类' },
  ];
}

export function getArticleBreadcrumb(articleSlug: string): BreadcrumbItem[] {
  const article = articles.find((a) => a.slug === articleSlug);
  const category = article ? categories.find((c) => c.slug === article.category) : null;
  const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];
  if (category) {
    items.push({ label: category.name, href: `/category/${category.slug}` });
  }
  items.push({ label: article?.title || '文章' });
  return items;
}

export function getAboutBreadcrumb(): BreadcrumbItem[] {
  return [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];
}